export default class FormSubmitVO
{

    isEmpty():boolean
    {
        return false;
    }

    getSubmitValue():any|null
    {
        return null;
    }
}